module.exports = __webpack_public_path__ + "img/yellowdanger.903ebe73.svg";